<template>
  <CommonPages id="services" classs="services-page" titlePrefix="Services - Buzzronic"
    metaDescription="A trusted ad marketplace designed to boost reach and revenue. Simplify ad trading with secure technology and high-quality inventory worldwide.">

    <div class="services-section">
      <h2 class="services-section__title">Our Services</h2>
      <p class="services-section__subtitle">We provide high-quality advertising resources to help
        advertisers scale their campaigns and maximize returns.</p>
      <div class="services-section__cards">
        <div class="service-card service-card--green">
          <img src="@/assets/service-1.svg" alt="Global Ad Network" />
          <h3>High-Quality Global Ad Network</h3>
          <p>Reach targeted audiences across 180+ countries with diverse ad formats, including
            display, video, and push notifications. Our network ensures brand-safe placements, wide
            coverage, and performance-driven results.</p>
        </div>
        <div class="service-card service-card--blue">
          <img src="@/assets/service-2.svg" alt="Analytics and Optimization" />
          <h3>Smart Analytics & Campaign Optimization</h3>
          <p>Monitor campaigns in real time with advanced analytics, AI-powered bid adjustments, and
            anti-fraud measures. Track clicks, impressions, and conversions to maximize ROI with
            precision.</p>
        </div>
        <div class="service-card service-card--red">
          <img src="@/assets/service-3.svg" alt="Personalized Solutions" />
          <h3>Personalized Solutions & Expert Support</h3>
          <p>Benefit from dedicated account management, custom campaign strategies, and seamless API
            integration. Whether you’re an advertiser or publisher, we provide solutions tailored to
            your objectives.</p>
        </div>
      </div>
    </div>

    <div class="partnerships-section">
      <div class="partnerships-section__content">
        <h2 class="partnerships-section__heading">Powerful Advertising Partnerships</h2>
        <p class="partnerships-section__text">We bridge advertisers and publishers with smart
          technology and trusted connections—driving results for both sides through premium traffic,
          data-driven optimization, and dedicated support.</p>
      </div>
      <div class="partnerships-section__images">
        <img src="@/assets/partnership-1.png" alt="Partnership Image 1"
          class="partnerships-section__image--left">
        <img src="@/assets/partnership-2.png" alt="Partnership Image 2"
          class="partnerships-section__image--right">
      </div>
    </div>
  </CommonPages>
</template>

<script>
import CommonPages from '@/pages/components/page_common.vue';
import '@/css/services.scss';

export default {
  name: 'Services',
  components: {
    CommonPages,
  },
};
</script>
